import React, { useState } from 'react';
import axios from 'axios';
import logo from '../assets/images/wordb_logo.svg';
import { FaArrowRight } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import RecoverPwd from '../components/RecoverPwd';
import { LuEyeClosed, LuEye } from "react-icons/lu";
import { API } from '../config'; 

const LogIn = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showRecoverPwd, setShowRecoverPwd] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);

    const validateForm = () => {
        //console.log("Validating login...");
        let errors = [];

        if (!username.trim()) {
            errors.push("Nickname is required.");
        }

        if (password.length < 4) {
            errors.push("Password must be at least 4 characters.");
        }

        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error)); // Show errors as toasts
            return false;
        }

        return true;
    };

    const handleLogIn = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        setIsLoggingIn(true);

        try {
            // Make the login request
            //opportunity - Stop hardcoding the API URL
            const response = await axios.post(`${API}/api/users/login`, {
                username: username.trim(),
                password,
            });
            //console.log('Response:', response.data); // Debugging: Log the response
            const token = response.data.token;
            localStorage.setItem('authToken', token); // Save the token
            //toast.success('Login successful!');
            onLogin(); // Trigger app-level login handling
        } catch (error) {
            console.error('Error:', error.response || error.message); // Debugging: Log errors
            toast.error(error.response?.data?.message || 'Error logging in.');
        } finally {
          // NEW BLOCK: reset submission state
          setIsLoggingIn(false);
      }
    };
    

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <section className='login signup'>

                {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
                {isQueryOpen && <Query onClose={toggleQuery} />}


                <Link to="/" className='back-link'>
                    <IoMdArrowRoundBack className='icon' /> 
                </Link>
                <div className="logo-div">
                    <img src={logo} alt="" />
                </div>

                <form className="login signup-form" onSubmit={handleLogIn}>
                    {/* Nickname Input */}
                    <div className="form-input">
                        <label htmlFor="nickname">Enter your Nickname</label>
                        <input 
                            type="text" 
                            id="nickname" 
                            name="nickname" 
                            placeholder="Bigfoot" 
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete='off'
                        />
                    </div>


                    {/* Password Input */}
                    <div className="form-input">
                        <label htmlFor="password">Enter your Password</label>
                        <input 
                            type={showPassword ? "text" : "password"}
                            id="password" 
                            name="password" 
                            placeholder="****" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete='off'
                        />
                        <span 
                            className="pwd-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            {showPassword ? <LuEye /> : <LuEyeClosed />}
                        </span>
                    </div>
        

                    {/* Submit Button */}
                    <button type="submit" className="signup-button">
                        <p className='btn-text'>{isLoggingIn ? 'Validating credentials…' : 'Log In & Play'}</p> <FaArrowRight className="icon"/>
                    </button>

                    {/* Login Link */}
                    <p className="login-text">
                        Don't have an account? &nbsp;
                        <Link to="/signup">Sign up now</Link>
                    </p>

                     <p className="login-text">
                        Forgot password?
                        <span onClick={() => setShowRecoverPwd(true)}> Recover now</span>
                    </p>
                </form>

                <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
            </section>

            <RecoverPwd
                show={showRecoverPwd}
                onClose={() => setShowRecoverPwd(false)}
            />
        </>
            
    );
};

export default LogIn;
